export default {
    title: 'justifyRight',
    action: [ 'justifyRight' ],
    description: 'Justify Right',
    icon: 'Right',
};
